import React from "react";
import {makeStyles} from "@material-ui/core";
import {full_stop} from "../../../common/constant";

const useStyles = makeStyles(() => ({
    "@keyframes flicker": {
        from: {
            opacity: 1
        },
        to: {
            opacity: 0
        }
    },
    flicker: {
        animationName: "$flicker",
        animationDuration: "1000ms",
        animationIterationCount: "infinite",
        "&:nth-child(2)": {
            "animation-delay": "250ms"
        },
        "&:nth-child(3)": {
            "animation-delay": "500ms"
        },
        "&:nth-child(5)": {
            "animation-delay": "250ms"
        },
        "&:nth-child(6)": {
            "animation-delay": "500ms"
        }
    },
}));

const EllipsisLoading = () => {

    const classes = useStyles();

    return (
        <>
            <span className={classes.flicker}>{full_stop}</span>
            <span className={classes.flicker}>{full_stop}</span>
            <span className={classes.flicker}>{full_stop}</span>
        </>
    );
};

export default EllipsisLoading;